import { ArrowUp, X } from 'lucide-react'
import { APP_HEADER_HEIGHT_PX } from '@/lib/layout'

// Gap between the bottom of the fixed app header and the pill
const PILL_GAP_PX = 2

interface NewPostsPillProps {
    onClick: () => void
    onDismiss?: () => void
    /** Additional vertical offset in px — used to push the pill down below the feed selector bar. */
    translateY?: number
}

export function NewPostsPill({ onClick, onDismiss, translateY = 0 }: NewPostsPillProps) {
    return (
        <div
            className="fixed inset-x-0 z-40 flex justify-center pointer-events-none transition-transform duration-300"
            style={{
                top: APP_HEADER_HEIGHT_PX + PILL_GAP_PX,
                transform: `translateY(${translateY}px)`,
            }}
        >
            <div className="flex items-center rounded-full bg-primary text-white text-sm font-medium shadow-lg pointer-events-auto animate-slide-down">
                <button onClick={onClick} className="flex items-center gap-1.5 pl-4 pr-3 py-2">
                    <ArrowUp className="w-4 h-4" aria-hidden="true" />
                    New posts
                </button>
                {onDismiss && (
                    <button
                        onClick={e => {
                            e.stopPropagation()
                            onDismiss()
                        }}
                        aria-label="Dismiss"
                        className="pr-3 py-2 opacity-80 hover:opacity-100 transition-opacity"
                    >
                        <X className="w-3.5 h-3.5" aria-hidden="true" />
                    </button>
                )}
            </div>
        </div>
    )
}
